import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'singleItemArray',
    standalone: false
})
export class SingleItemArrayPipe implements PipeTransform {
    transform(value: any): any {
        return value ? [value] : [];
    }
}
